// export const extractSlugDetails = (slug) => {
//     const parts = slug.split("-");

//     const inIndex = parts.indexOf("in");

//     if (inIndex === -1) {
//         return { services: "", suburb: "" }; 
//     }

//     const services = parts.slice(0, inIndex).join("-");
//     const suburb = parts.slice(inIndex + 1).join("-"); 

//     return { services, suburb };
// };

export const extractSlugDetails = (slug) => {
  if (!slug) return { services: "", suburb: "" };

  const parts = slug.split("-");
  const inIndex = parts.indexOf("in");

  if (inIndex === -1) {
    return { services: slug, suburb: "" };
  }

  const services = parts.slice(0, inIndex).join("-");
  const suburb = parts.slice(inIndex + 1).join("-");

  return { services, suburb };
};
